// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jo-0";